export const BULK_ISSUE_CREATE_SIDE_PANEL_ID = 'bulk-issue-create-side-panel';
export const BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH = 320;
export const ROVO_BULK_CREATE_SIDE_PANEL_WIDTH = 439;
